import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M12 10.9087L7.33312 16L6 14.5456L12 8L18 14.5456L16.6669 16L12 10.9087Z" />,
  'ArrowTopSLine'
);
